import { Component, OnInit } from '@angular/core';
import { AppIcon, AppIconColor, AppIconSize } from '@tablesready/frontend-icons';

@Component({
  selector: 'tr-help',
  templateUrl: './help-button.component.html',
  styleUrls: ['./help-button.component.scss'],
})
export class HelpButtonComponent implements OnInit {
  toggled = false;
  windowBeacon: any;
  icon = AppIcon;
  size = AppIconSize;
  color = AppIconColor;

  ngOnInit(): void {
    this.windowBeacon = (window as any).Beacon;
  }

  toggleBeacon(method: string): void {
    if (this.windowBeacon) {
      this.toggled = !this.toggled;

      return (window as any).Beacon(method);
    }
  }
}
